import { set, toggle, setPersist } from "@/app/plugins/store/helpers/vuex.js";

export default {
  setImage: set("image"),
  setColor: set("color"),
  setAutoOpen: setPersist("autoopen"),

  setDrawer: setPersist("drawer"),
  toggleDrawer: toggle("drawer"),

  setSecondaryDrawer: set("secondaryDrawer"),
  toggleSecondaryDrawer: toggle("secondaryDrawer")
};
